

export type PaginationMetaType = {
    itemsPerPage: number,
    totalItems: number,
    currentPage: number,
    totalPages: number,
    sortBy: Array<any>
}

export const PaginationMetaModel: PaginationMetaType = {
    itemsPerPage: 10,
    totalItems: 0,
    currentPage: 1,
    totalPages: 0,
    sortBy: []
}

export interface PaginationType {
    page?: number
    limit?: number
    sortBy?: Array<any>
    searchBy?: string[]
    search?: string
    filter?: any
    select?: string[]
    route: string
}

export type Params =  {
key: string
value: string | number | boolean
} []

export function prepareQueryParams(params) {
    let filter = 1;
    let query: string = '';
    let filterQuery: string = '';
    if (params.filter) {
        filter = params.filter;
        filterQuery = Object.keys(filter).map(key => 'filter.' + key + '=' + filter[key]).join('&');
        delete params.filter;
    }
    query = Object.keys(params).map(key => key + '=' + params[key]).join('&');
    return (filterQuery !== '') ? query + '&' + filterQuery : query;
}

export function buildQueryParams(params:Params){
let query: string = '';
query = params.map(param => param.key + '=' + param.value).join('&');
return query;
}

export function mediaFile(params:File[]) {
    const formData: FormData = new FormData();
    params.forEach((file: File) => {
      formData.append('file', file, file.name);
  });
  return formData;
  }